import { Injectable, Inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {
  constructor(@Inject('CONFIG_SETTINGS') private config: any) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const apiKey = this.config?.general?.apiKey;
    if (apiKey) {
      const cloned = req.clone({
        setHeaders: {
          'ocp-apim-subscription-key': apiKey
        }
      });
      return next.handle(cloned);
    }
    return next.handle(req);
  }
}
